import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { CheckAccessory } from './CheckAccessory'
import { ImageAccessory } from './ImageAccessory'

interface Props {
  src: string
}

export const AvatarItem: React.FC<Props> = ({ src }) => (
  <DropdownMenu.ContentItem left={CheckAccessory} reversed title="Custom">
    <ImageAccessory src={src} />
  </DropdownMenu.ContentItem>
)
